<template>
  <div :class="`${createRenderType}-ideas-main`" class="ideas-main">
    <div class="title">
      {{
        isPartyAtheme ? $$t("credit.partyNow") + " 🪩" : $$t("credit.turnIdeas")
      }}
    </div>
    <div
      :class="{
        'mode-box': true,
        'flex-center': true,
        'party-mode-box': isPartyAtheme,
      }"
    >
      <img
        v-if="!loading"
        class="dice pointer"
        src="@/assets/img/content/dice.png"
        alt=""
        @click="handleChangeText(true)"
      />
      <LoaderCircle
        v-if="loading"
        color="#fff"
        :size="createRenderType == 'pc' ? 24 : 20"
        :marginSize="2"
        :strokeWidth="2"
        :loading="loading"
      ></LoaderCircle>

      <input
        class="flex1 text-box"
        type="text"
        :placeholder="placeholder"
        v-model="description"
        @input="handleInput"
      />
      <div class="btn pointer" @click="handleCreate">
        {{ $$t("common.nav_create_music") }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, getCurrentInstance, onMounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import globalConfig from "@/config/config.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import message from "@/components/functionCallComponent/message/message.js";
import LoaderCircle from "@/components/animation/LoaderCircle.vue";
import tools from "@/utils/tools.js";
import feedListApi from "@/api/api/feedListApi.js";

const router = useRouter();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n;
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const userDataStore = useUserDataStore();
const feedListDataStore = useFeedListStore();

const props = defineProps({
  isPartyAtheme: {
    type: Boolean,
    default: false,
  },
});
const loading = ref(false);
const placeholder = ref("");
const description = ref("");
const lastId = ref(0);

const handleChangeText = (type) => {
  loading.value = true;
  if (type) {
    globalProperties.logClickEvent("home_dice", {});
  }
  const query = props.isPartyAtheme
    ? {
        genre: "Party Anthem",
        last_id: lastId.value,
      }
    : {
        last_id: lastId.value,
      };
  feedListApi.getPromptRandomData(query).then((res) => {
    loading.value = false;
    if (res.code == 200) {
      lastId.value = res.data?.prompt?.id;
      placeholder.value = res.data?.prompt?.content;
      description.value = "";
    }
  });
};

const handleCreate = async (init, value) => {
  if (loading.value) return;
  // createEasyModeStore.setPromptDataContent(description.value || placeholder.value);
  if (
    !(await userDataStore.checkLoginStatus(
      {
        rightType: "generate",
        create_type: "0",
        generate: "0",
        signup_source: "home_basic",
      },
      (isLogin) => {
        if (isLogin) {
          handleCreate(init);
        }
        console.log("doGernerate_home");
        localStorage.removeItem(`${globalConfig.appname}_create_data`);
      }
    ))
  ) {
    localStorage.setItem(
      `${globalConfig.appname}_create_data`,
      JSON.stringify({
        type: "easymodehome",
        timeScamps: new Date().getTime(),
        prompt: description.value || placeholder.value,
      })
    );
    globalProperties.logClickEvent("home_quick_create_button", {});
    return;
  }
  createLayoutStore.toggleCreateEditOpenState(false);
  router.push({
    name: "create",
  });
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.generating"),
  });
  feedListDataStore
    .doGenerateEasyMode(
      init,
      value ?? (description.value || placeholder.value),
      {
        membership_source1: "create",
        membership_source2: "home_basic",
      }
    )
    .then((res) => {
      closeMsg.clear();
    })
    .catch((err) => {
      closeMsg.clear();
    });
};

const handleInput = () => {
  handleInputChangeDebounceCall();
};

const handleInputChangeDebounceCall = tools.debounce(() => {
  globalProperties.logCustomEvent("home_quick_create", {}, "input");
}, 800);

const initGenerate = () => {
  if (userDataStore.isLogin) {
    let _create_data = localStorage.getItem(
      `${globalConfig.appname}_create_data`
    );
    try {
      _create_data = JSON.parse(_create_data);
      if (_create_data) {
        if (new Date().getTime() - _create_data?.timeScamps < 1000 * 60 * 60) {
          if (_create_data?.type == "easymodehome") {
            nextTick(() => {
              // createEasyModeStore.setPromptDataContent(_create_data.prompt || "");
              renderData.idea = _create_data?.prompt || "";
            }).then(() => {
              localStorage.removeItem(`${globalConfig.appname}_create_data`);
              handleCreate(true, _create_data.prompt || "");
              createLayoutStore.toggleCreateEditOpenState(true);
              createLayoutStore.setCreateEditMode("easy");
            });
          }
        }
      } else {
        _create_data = null;
        localStorage.removeItem(`${globalConfig.appname}_create_data`);
      }
    } catch (e) {
      _create_data = null;
      localStorage.removeItem(`${globalConfig.appname}_create_data`);
    }
  } else {
    localStorage.removeItem(`${globalConfig.appname}_create_data`);
  }
};
watch(
  () => {
    return userDataStore.isLogin;
  },
  () => {
    if (userDataStore.isLogin) {
      nextTick(() => {
        setTimeout(() => {
          initGenerate();
        }, 20);
      });
    }
  }
);
onMounted(() => {
  nextTick().then(() => {
    if (userDataStore.isLogin) {
      initGenerate();
    }
  });
  globalProperties.logViewEvent("home_quick_create_button", {});
  handleChangeText(false);
});
</script>

<style lang="scss" scoped>
.ideas-main {
  .title {
    color: #fff;
    font-weight: bold;
  }
  .mode-box {
    margin-top: 16px;
    background: rgba(148, 173, 255, 0.2);
    border: 1px solid #94adff;
    .text-box {
      margin-left: 16px;
      padding-right: 6px;
      background: transparent;
      border: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgba(255, 255, 255, 1);
      &::placeholder {
        color: rgba(255, 255, 255, 0.8) !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .btn {
      background: linear-gradient(112deg, #4fdeff 0%, #e675ff 100%);
      font-weight: 500;
      color: #000;
      line-height: 24px;
    }
  }
  .party-mode-box {
    background: linear-gradient(
      93deg,
      #7998ff 0%,
      #65af83 23%,
      #cadf9f 49%,
      #e584e0 74%,
      #b7aeff 100%
    );
    border: none;
    .text-box {
      color: rgba(255, 255, 255, 1);
      &::placeholder {
        color: rgba(255, 255, 255, 0.8) !important;
      }
    }
    .btn {
      background: linear-gradient(
        112deg,
        #ffffff 0%,
        #f7e3ff 50%,
        #ffffff 100%
      );
    }
  }
}

.pc-ideas-main {
  padding-bottom: 42px;
  .title {
    font-size: 32px;
    line-height: 42px;
  }
  .mode-box {
    width: 100%;
    height: 64px;
    border-radius: 60px;
    padding: 4px 4px 4px 24px;
    .dice {
      width: 24px;
      height: 24px;
      // margin-right: 16px;
    }
    .btn {
      padding: 16px 43px;
      font-size: 16px;
      border-radius: 60px;
    }
  }
}

.mobile-ideas-main {
  padding-bottom: 28px;
  .title {
    padding: 0 16px;
    font-size: 24px;
    line-height: 32px;
  }
  .mode-box {
    flex-shrink: 0;
    margin-left: 16px;
    margin-right: 16px;
    height: 56px;
    border-radius: 40px;
    padding: 4px 4px 4px 16px;
    .text-box {
      margin-left: 12px;
      font-size: 12px;
    }
    .dice {
      width: 20px;
      height: 20px;
    }
    .btn {
      padding: 12px 16px;
      font-size: 14px;
      border-radius: 40px;
    }
  }
}
</style>
